import { render } from "./PopupProfileCongrats.vue?vue&type=template&id=7dbbd75e"
import script from "./PopupProfileCongrats.vue?vue&type=script&lang=js"
export * from "./PopupProfileCongrats.vue?vue&type=script&lang=js"

import "./PopupProfileCongrats.vue?vue&type=style&index=0&id=7dbbd75e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__